// extracted by mini-css-extract-plugin
module.exports = {"links":"Footer_links__2pI3S","pattern":"Footer_pattern__1ttvY","p":"Footer_p__3EWTa","desktopP":"Footer_desktopP__3vcSm","mobileP":"Footer_mobileP__HRuCO"};